<template>
  <a-modal
    :title="modalTit"
    :visible.sync="isLimitDialogShow"
    width="542px"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    class="merge-form-modal"
    @ok="formHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div class="merge-form-tips">
      {{ $t('message["1581"]') }}。
    </div>
    <div class="merge-dilog-form">
      <a-form
        v-if="datas.notsame && datas.notsame.length > 0"
        :form="form"
        layout="inline"
      >
        <a-form-item
          v-for="item in datas.notsame"
          :key="item.key"
          :label="item.title"
        >
          <a-select
            v-decorator="[
              item.key,
              { initialValue: item.values[0].value },
            ]"
            :placeholder="selectPlaceholder"
          >
            <a-select-option
              v-for="(item2, index) in item.values"
              :key="item.key + index"
              :value="item2.value"
            >
              {{ item2.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { setAuth } from '@/lib/storage'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
  },
  props: {
    datas: {
      type: Object,
      default () {
        return {}
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      selectDatas: [
        {
          title: this.$t('message["200"]'),
          key: 'login',
          values: [
            {
              label: 'melodygo',
              value: 'melodygo'
            },
            {
              label: 'huang',
              value: 'huang123'
            }
          ]
        },
        {
          title: this.$t('message["665"]'),
          key: 'truename',
          values: [
            {
              label: 'melodygo1',
              value: 'melodygo1'
            },
            {
              label: 'huang1',
              value: 'huang1231'
            }
          ]
        },
        {
          title: this.$t('message["1116"]'),
          key: 'mobile',
          values: [
            {
              label: '15890618716',
              value: '15890618716'
            },
            {
              label: '18238821882',
              value: '18238821882'
            }
          ]
        },
        {
          title: this.$t('message["1505"]'),
          key: 'email',
          values: [
            {
              label: '15890618716@qq.com',
              value: '15890618716@qq.com'
            },
            {
              label: '18238821882@qq.com',
              value: '18238821882@qq.com'
            }
          ]
        },
        {
          title: this.$t('message["391"]'),
          key: 'gcw',
          values: [
            {
              label: 'melodygo',
              value: 'melodygo'
            },
            {
              label: 'melodygo2',
              value: 'melodygo2'
            }
          ]
        },
        {
          title: this.$t('message["1254"]'),
          key: 'wx',
          values: [
            {
              label: 'melodygo',
              value: 'melodygo'
            },
            {
              label: 'melodygo2',
              value: 'melodygo2'
            }
          ]
        }
      ]
    }
  },
  computed: {
    ...mapState('merge', ['decorators']),
    modalTit () {
      return this.$t('message["431"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  mounted () {
  },
  methods: {
    ...mapActions('merge', ['mergeForm']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle (formName) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          // this.$emit('subMergeForm', values)
          const chain = await this.mergeForm()
          chain.params({ notsame: values, binduserid: this.datas.binduserid })
            .onSuccess(raw => {
              this.isLimitDialogShow = false
              setAuth(raw.Authorization)
              this.$store.commit('setAuth', raw.Authorization, { root: true })
              if (this.type === 'bind1') {
                this.$router.push({ name: 'Merge', query: { param: this.$route.query.param, page: 3 } })
              } else {
                this.$router.push({ name: 'OrgIndex' })
              }
            })
            .fetch()
          // const chain = await this.ajaxSave()
          // chain.params(values)
          //   .onNetSuccess(d => {
          //     const res = d.data
          //     if (!res.error) {
          //       this.isLimitDialogShow = false
          //       // await this.$store.dispatch('login', res.payload.Authorization)
          //       setAuth(res.payload.Authorization)
          //       this.$store.commit('setAuth', res.payload.Authorization, { root: true })
          //       this.$router.push({ name: 'OrgIndex' })
          //       setTimeout(() => {
          //         location.reload()
          //       }, 1000)
          //     } else if (res.error === 104 || (res.error === 105)) {
          //       this.typeError = res
          //       this.isLimitDialogShow = false
          //       this.$refs.tipsDialog.changeLimitDialog(true)
          //     } else {
          //       this.$message.warning(res.message)
          //     }
          //   })
          //   .setForm(this.form)
          //   .config({ warn: false })
          //   .fetch()
          // this.form.resetFields()
          // this.isLimitDialogShow = false
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.merge-form-tips {
  height: 40px;
  margin: 0 -24px 24px;
  background: #E8F4FF;
  line-height: 40px;
  padding: 0 22px;
  color:#4CA0F2;
}
.merge-dilog-form::v-deep {
  margin-left: 20px;

  .ant-row:after {
    clear: both;
    content: '.';
    display: block;
    height: 0;
    visibility: hidden;
  }
  .ant-row {

    margin-bottom: 24px;
    padding-left: 100px;
    .ant-form-item-label {
      float: left;
      width: 80px;
      margin-left: -100px;
      label {
      color: #666;
      }
    }
    .ant-form-item-control-wrapper {
      float: left;
      width: 100%;
      .hide-icon {
        color: #999;
        margin-left: 16px;
      }
    }
  }
}
</style>
<style lang="scss">
.merge-form-modal {
  .ant-modal-title {
    line-height: 30px;
  }
  .ant-modal-close {
    top: 0;
  }
  .ant-modal-body {
    padding-top: 0;
  }
}
</style>
